import { useOutletContext } from "react-router";
import PipelineSettings from "../../components/template-modules/PipelineSettings";
import { IResourceDetails } from "../../types";


const ResourceSettingsPipeline = () => {
    const { resourceDetails } = useOutletContext<{ resourceDetails: IResourceDetails }>();

    return (
        <PipelineSettings pipelineId={resourceDetails.pipelineId} />
    );
}

export default ResourceSettingsPipeline;